import { createSelector } from 'reselect'
import { IDriverLocation } from 'types/Location'
import { IUserProfileStore, USER_STATES, IUserRecentShipment } from 'apps/user/types/user'

export const selectUserProfile = ({ userProfile }: IUserProfileStore) => userProfile

export const selectUserProfileDetails = ({ userProfile }: IUserProfileStore) =>
  userProfile.userProfileDetails

export const selectUserDriverLocations = (store: IUserProfileStore) =>
  store.userDriverLocations.driverLocations

export const selectLastKnownLocation = createSelector(
  selectUserDriverLocations,
  locations => locations && locations[0]
)

export const selectRecentShipments = (store: IUserProfileStore) =>
  store.recentShipments.shipmentList

export const selectLastKnownLocationShipment = createSelector(
  selectRecentShipments,
  selectLastKnownLocation,
  (shipments: IUserRecentShipment[], location?: IDriverLocation) =>
    shipments.find(ship => Number(location?.shipmentId) === Number(ship.id))
)

export const selectStops = createSelector(selectLastKnownLocationShipment, shipment => {
  if (shipment) {
    const { deliveries, pickups } = shipment
    return [...pickups, ...deliveries]
  }

  return undefined
})

export const selectNextStop = createSelector(
  selectLastKnownLocationShipment,
  selectStops,
  (shipment, stops) => {
    if (!shipment || !stops) return undefined

    return stops[shipment.status.currentStopIndex]
  }
)

export const selectUndeleted = ({ userProfile }: IUserProfileStore) => userProfile.undeleted

export const selectUndeletedId = createSelector(selectUndeleted, undeleted => undeleted.id)

export const selectUndeletedSuccess = createSelector(
  selectUndeleted,
  undeleted => undeleted.success
)

export const selectUndeleteError = createSelector(selectUndeleted, undeleted => undeleted.error)

export const selectUndeleteIsLoading = createSelector(
  selectUndeleted,
  undeleted => undeleted.loading
)

export const selectIsParentUserDeleted = ({ userProfile }: IUserProfileStore) =>
  userProfile.userProfileDetails?.stateName === USER_STATES.Deleted
